import React, { useState} from 'react'
import Select from 'react-select'
import { HTTP } from '../../../../api/resources'

export default function CustomField({ close, proceed, reservedNames, customFields }) {
    const [name, setName] = useState('')
    const [selectedType, setSelectedType] = useState()
    const [saving, setSaving] = useState(false)

    const handleSubmit = async() => {
        if (!validated()) return 
        setSaving(true)

        try {
            let response = await fieldRequest({name: name, value_type: selectedType.name.replace(' ', '_').toLowerCase()})
            setSaving(false)
            proceed(response.data)
            Alert.show('notice', 'New field created')
            close()
        } catch {
            Alert.show('error', 'Error creating field, please try again')
            setSaving(false)
        }
    }

    const validated = () => {
        let names = reservedNames.map(name => name.toLowerCase());

        if (names.includes(name.toLowerCase())) {
            Alert.show('error', 'Field name is reserved, please choose another name')
            return false
        }

        if (customFields.find(field => field.name.toLowerCase() === name.toLowerCase())) {
            Alert.show('error', 'Field name already exists, please choose another name')
            return false
        }

        return true
    }

    const fieldRequest = (data) => {
        return HTTP.post('/page/custom_fields', data)
    }
  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <h4>Create Custom Fields</h4>

                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label htmlFor='name'>Field Name</label>
                            <input type='text' step="1" className='form-control' name='name' id='name' placeholder='Field name' 
                                value={name} onChange={(event) => setName(event.target.value)}
                            />
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className="form-group" role="group" aria-labelledby="county">
                            <label id="country">Field Type</label>
                            <div className="input-group">
                                <Select
                                className="w-100"
                                onChange={(field) => {
                                    setSelectedType(field)
                                }}
                                options={[{name: 'Text', id: 1,}, {name: 'Long Text', id: 2}]}
                                getOptionLabel={(field) =>
                                    `${field.name}`
                                }
                                getOptionValue={(field) => field.id}
                                value={selectedType}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pt-3">
                    <button onClick={handleSubmit} type="button" className="btn btn-primary mr-2" disabled={!name || !selectedType || saving}>
                        Create Field
                    </button>

                    <button onClick={close} type="button" className="btn btn-secondary mr-2">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
 